import actionTypes from '../../site/constants/action-types';
import transactionSession from '../instance';

const resetTransactionSession = () => (next) => async (action) => {
  switch (action.type) {
    case actionTypes.RELOAD_SITE_META:
    case actionTypes.CONNECT_SITE: {
      transactionSession.reset();
      next(action);
      break;
    }
    default:
      next(action);
  }
};

export default resetTransactionSession;
